import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import IconExclamationSolid from "@/components/_icons/IconExclamationSolid";

export interface ErrorViewProps extends PropsWithChildren {
  text?: string;
}

export const ErrorView: FC<ErrorViewProps> = ({ text, children }) => {
  const { t } = useTranslation("common");
  return (
    <div className="align-center relative flex h-screen select-none justify-center overflow-auto">
      <div className="relative flex flex-col items-center self-center">
        <h4 className="relative flex grow items-stretch overflow-hidden align-middle text-sm">
          <IconExclamationSolid className="my-auto mr-2 h-3 w-3" aria-hidden="true" />
          {t("errors.pageErrorTitle")}
        </h4>
        <p className="mt-4 text-center text-sm text-muted-foreground">
          {text
            ? text
            : t("errors.pageError")}
        </p>
        {children && <div className="mt-4">{children}</div>}
      </div>
    </div>
  );
};
